import { t } from 'ttag';
import { LAYOUT_LIST, GAUGE, AudioDefinition } from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { CardHelper } from '~/training/sequence/templates/translators/itemHelpers/CardHelper';
import { ItemOfType } from '~/training/sequence/templates/translators/itemHelpers/types';

const getColorByIndex = (index: number) => {
  switch (index) {
    case 0:
      return '#F53258';
    case 1:
      return '#F78837';
    case 2:
      return '#F9BF60';
    case 3:
      return '#DBF337';
    case 4:
      return '#46E275';
    default:
      return '#' + Math.floor(Math.random() * 16777215).toString(16);
  }
};

const getSteps = (
  items?: Array<{
    id: string;
    value: string;
    subvalue?: string;
    feedback: string;
    feedbackAudios?: AudioDefinition;
  }>
) => {
  const steps: Array<{
    id: string;
    color: string;
    value: string | number;
    label: string;
    feedback?: string;
    feedbackAudios?: AudioDefinition;
  }> = [];

  (items || []).forEach((item, index, arr) => {
    const label =
      item.subvalue ||
      (steps.length == 0 ? '😡' : steps.length == arr.length - 1 ? '😀' : '');

    steps.push({
      id: item.id,
      color: getColorByIndex(index),
      value: item?.value,
      label: label,
      feedback: item?.feedback,
      feedbackAudios: item?.feedbackAudios
    });
  });

  return steps;
};

export const Interactive14: Translator = sequence => {
  const CardElement = sequence.items?.find(
    item => item.__typename == 'Card'
  ) as ItemOfType<'Card'>;

  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Question': {
        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            CardHelper(item as ItemOfType<'Question'>, {
              width: '500px',
              height: 'auto',
              align: 'left',
              extraItems: [
                {
                  type: GAUGE,
                  id: '1',
                  values: {
                    steps: getSteps(item.items as []),
                    from: CardElement
                      ? (CardElement?.title as string)
                      : t`Ineffective`,
                    to: CardElement
                      ? (CardElement.subtitle as string)
                      : t`Highly effective`,
                    shape: 'round'
                  },
                  items: []
                }
              ]
            })
          ]
        };
      }
      default:
        return null;
    }
  }, sequence.personalization);
};
